// Mock data for Walls Section Build Up based on documentation images

export interface BuildUpItem {
  id: string;
  description: string;
  length?: number;
  width?: number;
  height?: number;
  net: number;
  unit: string;
  rate: number;
  labour?: number;
  total: number;
}

export interface WallSpecification {
  id: string;
  name: string;
  type: 'garden' | 'drive' | 'concrete';
  category: string;
  items: BuildUpItem[];
  netTotal: number;
  ohpPercent: number;
  ohpAmount: number;
  grandTotal: number;
  prelimsPercent?: number;
}

// GRW600 specification from image
export const grw600Specification: WallSpecification = {
  id: 'grw600',
  name: 'GRW600',
  type: 'garden',
  category: 'Garden Retaining Walls',
  items: [
    {
      id: 'excavate_trench',
      description: 'Excavate trench and tip on site',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm3',
      rate: 18.25,
      total: 11.68
    },
    {
      id: 'compact_formation',
      description: 'Compact formation',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm2',
      rate: 0.38,
      total: 0.71
    },
    {
      id: 'concrete_blinding',
      description: 'Concrete Blinding',
      net: 0.00,
      unit: 'm3',
      rate: 253.49,
      total: 0.00
    },
    {
      id: 'a393_mesh',
      description: 'A393 Mesh',
      net: 0.00,
      unit: 'm2',
      rate: 11.96,
      total: 0.00
    },
    {
      id: 'a252_mesh',
      description: 'A252 Mesh',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm2',
      rate: 10.27,
      total: 8.73
    },
    {
      id: 'b503_mesh',
      description: 'B503 Mesh',
      net: 0.00,
      unit: 'm2',
      rate: 12.23,
      total: 0.00
    },
    {
      id: 'b785_mesh',
      description: 'B785 Mesh',
      net: 0.00,
      unit: 'm2',
      rate: 15.04,
      total: 0.00
    },
    {
      id: 'concrete_foundation',
      description: 'Concrete to foundation',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm3',
      rate: 224.01,
      total: 28.56
    },
    {
      id: 'blockwork_100_0_100',
      description: '100mm blockwork - 100',
      net: 0.00,
      unit: 'm2',
      rate: 37.62,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_220',
      description: '100mm blockwork - 220',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm2',
      rate: 75.24,
      total: 56.43
    },
    {
      id: 'blockwork_100_0_330',
      description: '100mm blockwork - 330',
      net: 0.00,
      unit: 'm2',
      rate: 112.86,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_440',
      description: '100mm blockwork - 440',
      net: 0.00,
      unit: 'm2',
      rate: 150.48,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_550',
      description: '100mm blockwork - 550',
      net: 0.00,
      unit: 'm2',
      rate: 188.10,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_660',
      description: '100mm blockwork - 660',
      net: 0.00,
      unit: 'm2',
      rate: 225.72,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_770',
      description: '100mm blockwork - 770',
      net: 0.00,
      unit: 'm2',
      rate: 263.34,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_880',
      description: '100mm blockwork - 880',
      net: 0.00,
      unit: 'm2',
      rate: 300.96,
      total: 0.00
    },
    {
      id: 'facing_bricks_05_wide',
      description: 'Facing bricks - 0.5 br wide',
      net: 0.00,
      unit: 'm2',
      rate: 48.51,
      total: 0.00
    },
    {
      id: 'facing_bricks_1_wide',
      description: 'Facing bricks - 1 br wide',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm2',
      rate: 97.02,
      total: 72.77
    },
    {
      id: 'facing_bricks_15_wide',
      description: 'Facing bricks - 1.5 br wide',
      net: 0.00,
      unit: 'm2',
      rate: 145.53,
      total: 0.00
    },
    {
      id: 'facing_bricks_2_wide',
      description: 'Facing bricks - 2.0 br wide',
      net: 0.00,
      unit: 'm2',
      rate: 194.04,
      total: 0.00
    },
    {
      id: 'facing_bricks_25_wide',
      description: 'Facing bricks - 2.5 br wide',
      net: 0.00,
      unit: 'm2',
      rate: 242.55,
      total: 0.00
    },
    {
      id: 'facing_bricks_3_wide',
      description: 'Facing bricks - 3.0 br wide',
      net: 0.00,
      unit: 'm2',
      rate: 291.06,
      total: 0.00
    },
    {
      id: 'facing_bricks_35_wide',
      description: 'Facing bricks - 3.5 br wide',
      net: 0.00,
      unit: 'm2',
      rate: 339.57,
      total: 0.00
    },
    {
      id: 'boe_coping_1_wide',
      description: 'BoE coping - 1 br wide',
      net: 0.00,
      unit: 'm',
      rate: 35.48,
      total: 35.48
    },
    {
      id: 'boe_coping_15_wide',
      description: 'BoE coping - 1.5 br wide',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm',
      rate: 53.22,
      total: 53.22
    },
    {
      id: 'boe_coping_2_wide',
      description: 'BoE coping - 2.0 br wide',
      net: 0.00,
      unit: 'm',
      rate: 70.96,
      total: 0.00
    },
    {
      id: 'boe_coping_25_wide',
      description: 'BoE coping - 2.5 br wide',
      net: 0.00,
      unit: 'm',
      rate: 88.70,
      total: 0.00
    },
    {
      id: 'as_dug_backfill',
      description: 'As dug Backfill',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm2',
      rate: 7.08,
      total: 0.15
    },
    {
      id: 'stockpile_onsite',
      description: 'Stockpile Onsite',
      net: 0.00,
      unit: 'm3',
      rate: 2.77,
      total: 1.71
    },
    {
      id: 'pipe_perforated',
      description: '150mm Ø perforated pipe',
      net: 0.00,
      unit: 'm',
      rate: 13.52,
      total: 13.52
    },
    {
      id: 'concrete_haunching',
      description: 'Concrete haunching',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm3',
      rate: 194.07,
      total: 4.16
    },
    {
      id: 'granular_backfill',
      description: 'Granular backfill',
      net: 0.00,
      unit: 'm3',
      rate: 75.11,
      total: 0.00
    },
    {
      id: 'waterproofing_1_coat',
      description: 'Waterproofing (RIW 1 coat)',
      net: 0.00,
      unit: 'm2',
      rate: 11.46,
      total: 0.00
    },
    {
      id: 'aquaseal_memb',
      description: 'Aquaseal memb',
      net: 0.00,
      unit: 'm2',
      rate: 12.96,
      total: 0.00
    },
    {
      id: 'waterproofing_2_coat',
      description: 'Waterproofing (RIW 2 coat + protection board)',
      net: 0.00,
      unit: 'm2',
      rate: 31.67,
      total: 44.65
    },
    {
      id: 'weepholes',
      description: '75 dia weepholes at 1000 ccs',
      net: 0.00,
      unit: 'nr',
      rate: 0.94,
      total: 0.94
    },
    {
      id: 'terram',
      description: 'Terram',
      net: 0.00,
      unit: 'm2',
      rate: 1.80,
      total: 0.00
    },
    {
      id: 'fence_post',
      description: 'Fence post at 2400mm ccs',
      net: 0.00,
      unit: 'nr',
      rate: 19.35,
      total: 8.11
    }
  ],
  netTotal: 337.91,
  ohpPercent: 15,
  ohpAmount: 51.15,
  grandTotal: 389.06
};

// GRW450 specification from image 1.png - exact data extraction
export const grw450Specification: WallSpecification = {
  id: 'grw450',
  name: 'GRW450',
  type: 'garden',
  category: 'Garden Retaining Walls',
  items: [
    {
      id: 'excavate_trench',
      description: 'Excavate trench and tip on site',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm3',
      rate: 18.25,
      total: 9.31
    },
    {
      id: 'compact_formation',
      description: 'Compact formation',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm2',
      rate: 0.38,
      total: 0.71
    },
    {
      id: 'concrete_blinding',
      description: 'Concrete Blinding',
      net: 0.00,
      unit: 'm3',
      rate: 253.49,
      total: 0.00
    },
    {
      id: 'a393_mesh',
      description: 'A393 Mesh',
      net: 0.00,
      unit: 'm2',
      rate: 11.96,
      total: 0.00
    },
    {
      id: 'a252_mesh',
      description: 'A252 Mesh',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm2',
      rate: 10.27,
      total: 8.73
    },
    {
      id: 'b503_mesh',
      description: 'B503 Mesh',
      net: 0.00,
      unit: 'm2',
      rate: 12.23,
      total: 0.00
    },
    {
      id: 'b785_mesh',
      description: 'B785 Mesh',
      net: 0.00,
      unit: 'm2',
      rate: 15.04,
      total: 0.00
    },
    {
      id: 'concrete_foundation',
      description: 'Concrete to foundation',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm3',
      rate: 224.01,
      total: 28.56
    },
    {
      id: 'blockwork_100_0_100',
      description: '100mm blockwork - 100',
      net: 0.00,
      unit: 'm2',
      rate: 37.62,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_220',
      description: '100mm blockwork - 220',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm2',
      rate: 75.24,
      total: 45.14
    },
    {
      id: 'blockwork_100_0_330',
      description: '100mm blockwork - 330',
      net: 0.00,
      unit: 'm2',
      rate: 112.86,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_440',
      description: '100mm blockwork - 440',
      net: 0.00,
      unit: 'm2',
      rate: 150.48,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_550',
      description: '100mm blockwork - 550',
      net: 0.00,
      unit: 'm2',
      rate: 188.10,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_660',
      description: '100mm blockwork - 660',
      net: 0.00,
      unit: 'm2',
      rate: 225.72,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_770',
      description: '100mm blockwork - 770',
      net: 0.00,
      unit: 'm2',
      rate: 263.34,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_880',
      description: '100mm blockwork - 880',
      net: 0.00,
      unit: 'm2',
      rate: 300.96,
      total: 0.00
    },
    {
      id: 'facing_bricks_05_wide',
      description: 'Facing bricks - 0.5 br wide',
      net: 0.00,
      unit: 'm2',
      rate: 48.51,
      total: 0.00
    },
    {
      id: 'facing_bricks_1_wide',
      description: 'Facing bricks - 1 br wide',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm2',
      rate: 97.02,
      total: 58.21
    },
    {
      id: 'facing_bricks_15_wide',
      description: 'Facing bricks - 1.5 br wide',
      net: 0.00,
      unit: 'm2',
      rate: 145.53,
      total: 0.00
    },
    {
      id: 'facing_bricks_2_wide',
      description: 'Facing bricks - 2.0 br wide',
      net: 0.00,
      unit: 'm2',
      rate: 194.04,
      total: 0.00
    },
    {
      id: 'facing_bricks_25_wide',
      description: 'Facing bricks - 2.5 br wide',
      net: 0.00,
      unit: 'm2',
      rate: 242.55,
      total: 0.00
    },
    {
      id: 'facing_bricks_3_wide',
      description: 'Facing bricks - 3.0 br wide',
      net: 0.00,
      unit: 'm2',
      rate: 291.06,
      total: 0.00
    },
    {
      id: 'facing_bricks_35_wide',
      description: 'Facing bricks - 3.5 br wide',
      net: 0.00,
      unit: 'm2',
      rate: 339.57,
      total: 0.00
    },
    {
      id: 'boe_coping_1_wide',
      description: 'BoE coping - 1 br wide',
      net: 0.00,
      unit: 'm',
      rate: 35.48,
      total: 35.48
    },
    {
      id: 'boe_coping_15_wide',
      description: 'BoE coping - 1.5 br wide',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm',
      rate: 53.22,
      total: 53.22
    },
    {
      id: 'boe_coping_2_wide',
      description: 'BoE coping - 2.0 br wide',
      net: 0.00,
      unit: 'm',
      rate: 70.96,
      total: 0.00
    },
    {
      id: 'boe_coping_25_wide',
      description: 'BoE coping - 2.5 br wide',
      net: 0.00,
      unit: 'm',
      rate: 88.70,
      total: 0.00
    },
    {
      id: 'as_dug_backfill',
      description: 'As dug Backfill',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm2',
      rate: 7.08,
      total: 0.15
    },
    {
      id: 'stockpile_onsite',
      description: 'Stockpile Onsite',
      net: 0.00,
      unit: 'm3',
      rate: 2.77,
      total: 1.35
    },
    {
      id: 'pipe_perforated',
      description: '150mm Ø perforated pipe',
      net: 0.00,
      unit: 'm',
      rate: 13.52,
      total: 13.52
    },
    {
      id: 'concrete_haunching',
      description: 'Concrete haunching',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm3',
      rate: 194.07,
      total: 4.16
    },
    {
      id: 'granular_backfill',
      description: 'Granular backfill',
      net: 0.00,
      unit: 'm3',
      rate: 75.11,
      total: 0.00
    },
    {
      id: 'waterproofing_1_coat',
      description: 'Waterproofing (RIW 1 coat)',
      net: 0.00,
      unit: 'm2',
      rate: 11.46,
      total: 0.00
    },
    {
      id: 'aquaseal_memb',
      description: 'Aquaseal memb',
      net: 0.00,
      unit: 'm2',
      rate: 12.96,
      total: 0.00
    },
    {
      id: 'waterproofing_2_coat',
      description: 'Waterproofing (RIW 2 coat + protection board)',
      net: 0.00,
      unit: 'm2',
      rate: 31.67,
      total: 44.65
    },
    {
      id: 'weepholes',
      description: '75 dia weepholes at 1000 ccs',
      net: 0.00,
      unit: 'nr',
      rate: 0.94,
      total: 0.94
    },
    {
      id: 'terram',
      description: 'Terram',
      net: 0.00,
      unit: 'm2',
      rate: 1.80,
      total: 0.00
    },
    {
      id: 'fence_post',
      description: 'Fence post at 2400mm ccs',
      net: 0.00,
      unit: 'nr',
      rate: 19.35,
      total: 8.11
    }
  ],
  netTotal: 310.22,
  ohpPercent: 15,
  ohpAmount: 46.53,
  grandTotal: 356.75
};


// DRW450 specification from image 1.png - Drive Retaining Walls
export const drw450Specification: WallSpecification = {
  id: 'drw450',
  name: 'DRW450',
  type: 'drive',
  category: 'Drive Retaining Walls',
  items: [
    {
      id: 'excavate_trench',
      description: 'Excavate trench and tip on site',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm3',
      rate: 18.25,
      total: 6.16
    },
    {
      id: 'compact_formation',
      description: 'Compact formation',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm2',
      rate: 0.85,
      total: 0.42
    },
    {
      id: 'concrete_blinding',
      description: 'Concrete Blinding',
      net: 0.00,
      unit: 'm3',
      rate: 253.49,
      total: 0.00
    },
    {
      id: 'a393_mesh',
      description: 'A393 Mesh',
      net: 0.00,
      unit: 'm2',
      rate: 11.96,
      total: 0.00
    },
    {
      id: 'a252_mesh',
      description: 'A252 Mesh',
      net: 0.00,
      unit: 'm2',
      rate: 10.27,
      total: 0.00
    },
    {
      id: 'b503_mesh',
      description: 'B503 Mesh',
      net: 0.00,
      unit: 'm2',
      rate: 12.23,
      total: 0.00
    },
    {
      id: 'b785_mesh',
      description: 'B785 Mesh',
      net: 0.00,
      unit: 'm2',
      rate: 15.04,
      total: 0.00
    },
    {
      id: 'concrete_foundation',
      description: 'Concrete to foundation',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm3',
      rate: 224.01,
      total: 33.60
    },
    {
      id: 'blockwork_100_0_100',
      description: '100mm blockwork - 100',
      net: 0.00,
      unit: 'm2',
      rate: 37.62,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_220',
      description: '100mm blockwork - 220',
      net: 0.00,
      unit: 'm2',
      rate: 75.24,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_330',
      description: '100mm blockwork - 330',
      net: 0.00,
      unit: 'm2',
      rate: 112.86,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_440',
      description: '100mm blockwork - 440',
      net: 0.00,
      unit: 'm2',
      rate: 150.48,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_550',
      description: '100mm blockwork - 550',
      net: 0.00,
      unit: 'm2',
      rate: 188.10,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_660',
      description: '100mm blockwork - 660',
      net: 0.00,
      unit: 'm2',
      rate: 225.72,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_770',
      description: '100mm blockwork - 770',
      net: 0.00,
      unit: 'm2',
      rate: 263.34,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_880',
      description: '100mm blockwork - 880',
      net: 0.00,
      unit: 'm2',
      rate: 300.96,
      total: 0.00
    },
    {
      id: 'facing_bricks_05_wide',
      description: 'Facing bricks - 0.5 br wide',
      net: 0.00,
      unit: 'm2',
      rate: 48.51,
      total: 0.00
    },
    {
      id: 'facing_bricks_1_wide',
      description: 'Facing bricks - 1 br wide',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm2',
      rate: 97.02,
      total: 72.77
    },
    {
      id: 'facing_bricks_15_wide',
      description: 'Facing bricks - 1.5 br wide',
      net: 0.00,
      unit: 'm2',
      rate: 145.53,
      total: 0.00
    },
    {
      id: 'facing_bricks_2_wide',
      description: 'Facing bricks - 2.0 br wide',
      net: 0.00,
      unit: 'm2',
      rate: 194.04,
      total: 0.00
    },
    {
      id: 'facing_bricks_25_wide',
      description: 'Facing bricks - 2.5 br wide',
      net: 0.00,
      unit: 'm2',
      rate: 242.55,
      total: 0.00
    },
    {
      id: 'facing_bricks_3_wide',
      description: 'Facing bricks - 3.0 br wide',
      net: 0.00,
      unit: 'm2',
      rate: 291.06,
      total: 0.00
    },
    {
      id: 'facing_bricks_35_wide',
      description: 'Facing bricks - 3.5 br wide',
      net: 0.00,
      unit: 'm2',
      rate: 339.57,
      total: 0.00
    },
    {
      id: 'boe_coping_1_wide',
      description: 'BoE coping - 1 br wide',
      net: 0.00,
      unit: 'm',
      rate: 35.48,
      total: 35.48
    },
    {
      id: 'boe_coping_15_wide',
      description: 'BoE coping - 1.5 br wide',
      net: 0.00,
      unit: 'm',
      rate: 53.22,
      total: 0.00
    },
    {
      id: 'boe_coping_2_wide',
      description: 'BoE coping - 2.0 br wide',
      net: 0.00,
      unit: 'm',
      rate: 70.96,
      total: 0.00
    },
    {
      id: 'boe_coping_25_wide',
      description: 'BoE coping - 2.5 br wide',
      net: 0.00,
      unit: 'm',
      rate: 88.70,
      total: 0.00
    },
    {
      id: 'as_dug_backfill',
      description: 'As dug Backfill',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm2',
      rate: 7.08,
      total: 0.15
    },
    {
      id: 'stockpile_onsite',
      description: 'Stockpile Onsite',
      net: 0.00,
      unit: 'm3',
      rate: 2.77,
      total: 0.88
    },
    {
      id: 'pipe_perforated',
      description: '150mm Ø perforated pipe',
      net: 0.00,
      unit: 'm',
      rate: 13.52,
      total: 0.00
    },
    {
      id: 'concrete_haunching',
      description: 'Concrete haunching',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm3',
      rate: 194.07,
      total: 4.16
    },
    {
      id: 'granular_backfill',
      description: 'Granular backfill',
      net: 0.00,
      unit: 'm3',
      rate: 75.11,
      total: 0.00
    },
    {
      id: 'waterproofing_1_coat',
      description: 'Waterproofing (RIW 1 coat)',
      net: 0.00,
      unit: 'm2',
      rate: 11.46,
      total: 0.00
    },
    {
      id: 'aquaseal_memb',
      description: 'Aquaseal memb',
      net: 0.00,
      unit: 'm2',
      rate: 12.96,
      total: 0.00
    },
    {
      id: 'waterproofing_2_coat',
      description: 'Waterproofing (RIW 2 coat + protection board)',
      net: 0.00,
      unit: 'm2',
      rate: 31.67,
      total: 0.00
    },
    {
      id: 'weepholes',
      description: '75 dia weepholes at 1000 ccs',
      net: 0.00,
      unit: 'nr',
      rate: 0.94,
      total: 0.94
    },
    {
      id: 'terram',
      description: 'Terram',
      net: 0.00,
      unit: 'm2',
      rate: 1.80,
      total: 0.00
    },
    {
      id: 'fence_post',
      description: 'Fence post at 2400mm ccs',
      net: 0.00,
      unit: 'nr',
      rate: 19.35,
      total: 8.13
    }
  ],
  netTotal: 162.86,
  ohpPercent: 15,
  ohpAmount: 24.43,
  grandTotal: 187.29
};

// DRW600 specification from image 2.png - Drive Retaining Walls
export const drw600Specification: WallSpecification = {
  id: 'drw600',
  name: 'DRW600',
  type: 'drive',
  category: 'Drive Retaining Walls',
  items: [
    {
      id: 'excavate_trench',
      description: 'Excavate trench and tip on site',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm3',
      rate: 18.25,
      total: 6.16
    },
    {
      id: 'compact_formation',
      description: 'Compact formation',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm2',
      rate: 0.85,
      total: 0.42
    },
    {
      id: 'concrete_blinding',
      description: 'Concrete Blinding',
      net: 0.00,
      unit: 'm3',
      rate: 253.49,
      total: 0.00
    },
    {
      id: 'a393_mesh',
      description: 'A393 Mesh',
      net: 0.00,
      unit: 'm2',
      rate: 11.96,
      total: 0.00
    },
    {
      id: 'a252_mesh',
      description: 'A252 Mesh',
      net: 0.00,
      unit: 'm2',
      rate: 10.27,
      total: 0.00
    },
    {
      id: 'b503_mesh',
      description: 'B503 Mesh',
      net: 0.00,
      unit: 'm2',
      rate: 12.23,
      total: 0.00
    },
    {
      id: 'b785_mesh',
      description: 'B785 Mesh',
      net: 0.00,
      unit: 'm2',
      rate: 15.04,
      total: 0.00
    },
    {
      id: 'concrete_foundation',
      description: 'Concrete to foundation',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm3',
      rate: 224.01,
      total: 33.60
    },
    {
      id: 'blockwork_100_0_100',
      description: '100mm blockwork - 100',
      net: 0.00,
      unit: 'm2',
      rate: 37.62,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_220',
      description: '100mm blockwork - 220',
      net: 0.00,
      unit: 'm2',
      rate: 75.24,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_330',
      description: 'blockwork - 330',
      net: 0.00,
      unit: 'm2',
      rate: 112.86,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_440',
      description: '100mm blockwork - 440',
      net: 0.00,
      unit: 'm2',
      rate: 150.48,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_550',
      description: '100mm blockwork - 550',
      net: 0.00,
      unit: 'm2',
      rate: 188.10,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_660',
      description: '100mm blockwork - 660',
      net: 0.00,
      unit: 'm2',
      rate: 225.72,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_770',
      description: '100mm blockwork - 770',
      net: 0.00,
      unit: 'm2',
      rate: 263.34,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_880',
      description: '100mm blockwork - 880',
      net: 0.00,
      unit: 'm2',
      rate: 300.96,
      total: 0.00
    },
    {
      id: 'facing_bricks_05_wide',
      description: 'Facing bricks - 0.5 br wide',
      net: 0.00,
      unit: 'm2',
      rate: 48.51,
      total: 0.00
    },
    {
      id: 'facing_bricks_1_wide',
      description: 'Facing bricks - 1 br wide',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm2',
      rate: 97.02,
      total: 72.77
    },
    {
      id: 'facing_bricks_15_wide',
      description: 'Facing bricks - 1.5 br wide',
      net: 0.00,
      unit: 'm2',
      rate: 145.53,
      total: 0.00
    },
    {
      id: 'facing_bricks_2_wide',
      description: 'Facing bricks - 2.0 br wide',
      net: 0.00,
      unit: 'm2',
      rate: 194.04,
      total: 0.00
    },
    {
      id: 'facing_bricks_25_wide',
      description: 'Facing bricks - 2.5 br wide',
      net: 0.00,
      unit: 'm2',
      rate: 242.55,
      total: 0.00
    },
    {
      id: 'facing_bricks_3_wide',
      description: 'Facing bricks - 3.0 br wide',
      net: 0.00,
      unit: 'm2',
      rate: 291.06,
      total: 0.00
    },
    {
      id: 'facing_bricks_35_wide',
      description: 'Facing bricks - 3.5 br wide',
      net: 0.00,
      unit: 'm2',
      rate: 339.57,
      total: 0.00
    },
    {
      id: 'boe_coping_1_wide',
      description: 'BoE coping - 1 br wide',
      net: 0.00,
      unit: 'm',
      rate: 35.48,
      total: 35.48
    },
    {
      id: 'boe_coping_15_wide',
      description: 'BoE coping - 1.5 br wide',
      net: 0.00,
      unit: 'm',
      rate: 53.22,
      total: 0.00
    },
    {
      id: 'boe_coping_2_wide',
      description: 'BoE coping - 2.0 br wide',
      net: 0.00,
      unit: 'm',
      rate: 70.96,
      total: 0.00
    },
    {
      id: 'boe_coping_25_wide',
      description: 'BoE coping - 2.5 br wide',
      net: 0.00,
      unit: 'm',
      rate: 88.70,
      total: 0.00
    },
    {
      id: 'as_dug_backfill',
      description: 'As dug Backfill',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm2',
      rate: 7.08,
      total: 0.15
    },
    {
      id: 'stockpile_onsite',
      description: 'Stockpile Onsite',
      net: 0.00,
      unit: 'm3',
      rate: 2.77,
      total: 0.88
    },
    {
      id: 'pipe_perforated',
      description: '150mm Ø perforated pipe',
      net: 0.00,
      unit: 'm',
      rate: 13.52,
      total: 0.00
    },
    {
      id: 'concrete_haunching',
      description: 'Concrete haunching',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm3',
      rate: 194.07,
      total: 4.16
    },
    {
      id: 'granular_backfill',
      description: 'Granular backfill',
      net: 0.00,
      unit: 'm3',
      rate: 75.11,
      total: 0.00
    },
    {
      id: 'waterproofing_1_coat',
      description: 'Waterproofing (RIW 1 coat)',
      net: 0.00,
      unit: 'm2',
      rate: 11.46,
      total: 0.00
    },
    {
      id: 'aquaseal_memb',
      description: 'Aquaseal memb',
      net: 0.00,
      unit: 'm2',
      rate: 12.96,
      total: 0.00
    },
    {
      id: 'waterproofing_2_coat',
      description: 'Waterproofing (RIW 2 coat + protection board)',
      net: 0.00,
      unit: 'm2',
      rate: 31.67,
      total: 0.00
    },
    {
      id: 'weepholes',
      description: '75 dia weepholes at 1000 ccs',
      net: 0.00,
      unit: 'nr',
      rate: 0.94,
      total: 0.94
    },
    {
      id: 'terram',
      description: 'Terram',
      net: 0.00,
      unit: 'm2',
      rate: 1.80,
      total: 0.00
    },
    {
      id: 'fence_post',
      description: 'Fence post at 2400mm ccs',
      net: 0.00,
      unit: 'nr',
      rate: 19.35,
      total: 8.13
    }
  ],
  netTotal: 162.86,
  ohpPercent: 15,
  ohpAmount: 24.43,
  grandTotal: 187.29
};

// DRW750 specification - Drive Retaining Walls 750mm
export const drw750Specification: WallSpecification = {
  id: 'drw750',
  name: 'DRW750',
  type: 'drive',
  category: 'Drive Retaining Walls',
  items: [
    {
      id: 'excavate_trench',
      description: 'Excavate trench and tip on site',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm3',
      rate: 18.25,
      total: 7.48
    },
    {
      id: 'compact_formation',
      description: 'Compact formation',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm2',
      rate: 0.85,
      total: 0.42
    },
    {
      id: 'concrete_blinding',
      description: 'Concrete Blinding',
      net: 0.00,
      unit: 'm3',
      rate: 253.49,
      total: 0.00
    },
    {
      id: 'a393_mesh',
      description: 'A393 Mesh',
      net: 0.00,
      unit: 'm2',
      rate: 11.96,
      total: 0.00
    },
    {
      id: 'a252_mesh',
      description: 'A252 Mesh',
      net: 0.00,
      unit: 'm2',
      rate: 10.27,
      total: 0.00
    },
    {
      id: 'b503_mesh',
      description: 'B503 Mesh',
      net: 0.00,
      unit: 'm2',
      rate: 12.23,
      total: 0.00
    },
    {
      id: 'b785_mesh',
      description: 'B785 Mesh',
      net: 0.00,
      unit: 'm2',
      rate: 15.04,
      total: 0.00
    },
    {
      id: 'concrete_foundation',
      description: 'Concrete to foundation',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm3',
      rate: 224.01,
      total: 39.60
    },
    {
      id: 'blockwork_100_0_100',
      description: '100mm blockwork - 100',
      net: 0.00,
      unit: 'm2',
      rate: 37.62,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_220',
      description: '100mm blockwork - 220',
      net: 0.00,
      unit: 'm2',
      rate: 75.24,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_330',
      description: '100mm blockwork - 330',
      net: 0.00,
      unit: 'm2',
      rate: 112.86,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_440',
      description: '100mm blockwork - 440',
      net: 0.00,
      unit: 'm2',
      rate: 150.48,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_550',
      description: '100mm blockwork - 550',
      net: 0.00,
      unit: 'm2',
      rate: 188.10,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_660',
      description: '100mm blockwork - 660',
      net: 0.00,
      unit: 'm2',
      rate: 225.72,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_770',
      description: '100mm blockwork - 770',
      net: 0.00,
      unit: 'm2',
      rate: 263.34,
      total: 0.00
    },
    {
      id: 'blockwork_100_0_880',
      description: '100mm blockwork - 880',
      net: 0.00,
      unit: 'm2',
      rate: 300.96,
      total: 0.00
    },
    {
      id: 'facing_bricks_05_wide',
      description: 'Facing bricks - 0.5 br wide',
      net: 0.00,
      unit: 'm2',
      rate: 48.51,
      total: 0.00
    },
    {
      id: 'facing_bricks_1_wide',
      description: 'Facing bricks - 1 br wide',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm2',
      rate: 97.02,
      total: 72.77
    },
    {
      id: 'facing_bricks_15_wide',
      description: 'Facing bricks - 1.5 br wide',
      net: 0.00,
      unit: 'm2',
      rate: 145.53,
      total: 0.00
    },
    {
      id: 'facing_bricks_2_wide',
      description: 'Facing bricks - 2.0 br wide',
      net: 0.00,
      unit: 'm2',
      rate: 194.04,
      total: 0.00
    },
    {
      id: 'facing_bricks_25_wide',
      description: 'Facing bricks - 2.5 br wide',
      net: 0.00,
      unit: 'm2',
      rate: 242.55,
      total: 0.00
    },
    {
      id: 'facing_bricks_3_wide',
      description: 'Facing bricks - 3.0 br wide',
      net: 0.00,
      unit: 'm2',
      rate: 291.06,
      total: 0.00
    },
    {
      id: 'facing_bricks_35_wide',
      description: 'Facing bricks - 3.5 br wide',
      net: 0.00,
      unit: 'm2',
      rate: 339.57,
      total: 0.00
    },
    {
      id: 'boe_coping_1_wide',
      description: 'BoE coping - 1 br wide',
      net: 0.00,
      unit: 'm',
      rate: 35.48,
      total: 35.48
    },
    {
      id: 'boe_coping_15_wide',
      description: 'BoE coping - 1.5 br wide',
      net: 0.00,
      unit: 'm',
      rate: 53.22,
      total: 0.00
    },
    {
      id: 'boe_coping_2_wide',
      description: 'BoE coping - 2.0 br wide',
      net: 0.00,
      unit: 'm',
      rate: 70.96,
      total: 0.00
    },
    {
      id: 'boe_coping_25_wide',
      description: 'BoE coping - 2.5 br wide',
      net: 0.00,
      unit: 'm',
      rate: 88.70,
      total: 0.00
    },
    {
      id: 'as_dug_backfill',
      description: 'As dug Backfill',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm2',
      rate: 7.08,
      total: 0.15
    },
    {
      id: 'stockpile_onsite',
      description: 'Stockpile Onsite',
      net: 0.00,
      unit: 'm3',
      rate: 2.77,
      total: 1.08
    },
    {
      id: 'pipe_perforated',
      description: '150mm Ø perforated pipe',
      net: 0.00,
      unit: 'm',
      rate: 13.52,
      total: 0.00
    },
    {
      id: 'concrete_haunching',
      description: 'Concrete haunching',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm3',
      rate: 194.07,
      total: 4.16
    },
    {
      id: 'granular_backfill',
      description: 'Granular backfill',
      net: 0.00,
      unit: 'm3',
      rate: 75.11,
      total: 0.00
    },
    {
      id: 'waterproofing_1_coat',
      description: 'Waterproofing (RIW 1 coat)',
      net: 0.00,
      unit: 'm2',
      rate: 11.46,
      total: 0.00
    },
    {
      id: 'aquaseal_memb',
      description: 'Aquaseal memb',
      net: 0.00,
      unit: 'm2',
      rate: 12.96,
      total: 0.00
    },
    {
      id: 'waterproofing_2_coat',
      description: 'Waterproofing (RIW 2 coat + protection board)',
      net: 0.00,
      unit: 'm2',
      rate: 31.67,
      total: 0.00
    },
    {
      id: 'weepholes',
      description: '75 dia weepholes at 1000 ccs',
      net: 0.00,
      unit: 'nr',
      rate: 0.94,
      total: 0.94
    },
    {
      id: 'terram',
      description: 'Terram',
      net: 0.00,
      unit: 'm2',
      rate: 1.80,
      total: 0.00
    },
    {
      id: 'fence_post',
      description: 'Fence post at 2400mm ccs',
      net: 0.00,
      unit: 'nr',
      rate: 19.35,
      total: 8.13
    }
  ],
  netTotal: 170.21,
  ohpPercent: 15,
  ohpAmount: 25.53,
  grandTotal: 195.74
};

// Helper function to create GRW specifications
const createGRWSpecification = (height: string, netTotal: number): WallSpecification => ({
  id: `grw${height}`,
  name: `GRW${height}`,
  type: 'garden',
  category: 'Garden Retaining Walls',
  items: [
    { id: 'excavate_trench', description: 'Excavate trench and tip on site', net: 0.00, unit: 'm3', rate: 18.25, total: 0 },
    { id: 'compact_formation', description: 'Compact formation', net: 0.00, unit: 'm2', rate: 0.38, total: 0 },
    { id: 'concrete_blinding', description: 'Concrete Blinding', net: 0.00, unit: 'm3', rate: 253.49, total: 0 },
    { id: 'a393_mesh', description: 'A393 Mesh', net: 0.00, unit: 'm2', rate: 11.96, total: 0 },
    { id: 'a252_mesh', description: 'A252 Mesh', net: 0.00, unit: 'm2', rate: 10.27, total: 0 },
    { id: 'b503_mesh', description: 'B503 Mesh', net: 0.00, unit: 'm2', rate: 12.23, total: 0 },
    { id: 'b785_mesh', description: 'B785 Mesh', net: 0.00, unit: 'm2', rate: 15.04, total: 0 },
    { id: 'concrete_foundation', description: 'Concrete to foundation', net: 0.00, unit: 'm3', rate: 224.01, total: 0 },
    { id: 'blockwork_100_0_220', description: '100mm blockwork - 220', net: 0.00, unit: 'm2', rate: 75.24, total: 0 },
    { id: 'facing_bricks_1_wide', description: 'Facing bricks - 1 br wide', net: 0.00, unit: 'm2', rate: 97.02, total: 0 },
    { id: 'boe_coping_1_wide', description: 'BoE coping - 1 br wide', net: 0.00, unit: 'm', rate: 35.48, total: 0 },
    { id: 'boe_coping_15_wide', description: 'BoE coping - 1.5 br wide', net: 0.00, unit: 'm', rate: 53.22, total: 0 },
    { id: 'as_dug_backfill', description: 'As dug Backfill', net: 0.00, unit: 'm2', rate: 7.08, total: 0 },
    { id: 'stockpile_onsite', description: 'Stockpile Onsite', net: 0.00, unit: 'm3', rate: 2.77, total: 0 },
    { id: 'pipe_perforated', description: '150mm Ø perforated pipe', net: 0.00, unit: 'm', rate: 13.52, total: 0 },
    { id: 'concrete_haunching', description: 'Concrete haunching', net: 0.00, unit: 'm3', rate: 194.07, total: 0 },
    { id: 'waterproofing_2_coat', description: 'Waterproofing (RIW 2 coat + protection board)', net: 0.00, unit: 'm2', rate: 31.67, total: 0 },
    { id: 'weepholes', description: '75 dia weepholes at 1000 ccs', net: 0.00, unit: 'nr', rate: 0.94, total: 0 },
    { id: 'fence_post', description: 'Fence post at 2400mm ccs', net: 0.00, unit: 'nr', rate: 19.35, total: 0 }
  ],
  netTotal,
  ohpPercent: 15,
  ohpAmount: netTotal * 0.15,
  grandTotal: netTotal * 1.15
});

// Helper function to create DRW specifications
const createDRWSpecification = (height: string, netTotal: number): WallSpecification => ({
  id: `drw${height}`,
  name: `DRW${height}`,
  type: 'drive',
  category: 'Drive Retaining Walls',
  items: [
    { id: 'excavate_trench', description: 'Excavate trench and tip on site', net: 0.00, unit: 'm3', rate: 18.25, total: 0 },
    { id: 'compact_formation', description: 'Compact formation', net: 0.00, unit: 'm2', rate: 0.85, total: 0 },
    { id: 'concrete_foundation', description: 'Concrete to foundation', net: 0.00, unit: 'm3', rate: 224.01, total: 0 },
    { id: 'facing_bricks_1_wide', description: 'Facing bricks - 1 br wide', net: 0.00, unit: 'm2', rate: 97.02, total: 0 },
    { id: 'boe_coping_1_wide', description: 'BoE coping - 1 br wide', net: 0.00, unit: 'm', rate: 35.48, total: 0 },
    { id: 'as_dug_backfill', description: 'As dug Backfill', net: 0.00, unit: 'm2', rate: 7.08, total: 0 },
    { id: 'stockpile_onsite', description: 'Stockpile Onsite', net: 0.00, unit: 'm3', rate: 2.77, total: 0 },
    { id: 'concrete_haunching', description: 'Concrete haunching', net: 0.00, unit: 'm3', rate: 194.07, total: 0 },
    { id: 'weepholes', description: '75 dia weepholes at 1000 ccs', net: 0.00, unit: 'nr', rate: 0.94, total: 0 },
    { id: 'fence_post', description: 'Fence post at 2400mm ccs', net: 0.00, unit: 'nr', rate: 19.35, total: 0 }
  ],
  netTotal,
  ohpPercent: 15,
  ohpAmount: netTotal * 0.15,
  grandTotal: netTotal * 1.15
});

// Helper function to create CCRW specifications (Concrete Core Retaining Walls)
const createCCRWSpecification = (height: string, netTotal: number): WallSpecification => ({
  id: `ccrw${height}`,
  name: `CCRW${height}`,
  type: 'concrete',
  category: 'Concrete Core Retaining Walls',
  items: [
    { id: 'excavate_trench', description: 'Excavate trench and tip on site', net: 0.00, unit: 'm3', rate: 18.25, total: 0 },
    { id: 'compact_formation', description: 'Compact formation', net: 0.00, unit: 'm2', rate: 0.85, total: 0 },
    { id: 'concrete_blinding', description: 'Concrete Blinding', net: 0.00, unit: 'm3', rate: 253.49, total: 0 },
    { id: 'a393_mesh', description: 'A393 Mesh', net: 0.00, unit: 'm2', rate: 11.96, total: 0 },
    { id: 'concrete_foundation', description: 'Concrete to foundation', net: 0.00, unit: 'm3', rate: 224.01, total: 0 },
    { id: 'concrete_core', description: 'Concrete core wall', net: 0.00, unit: 'm3', rate: 280.00, total: 0 },
    { id: 'facing_bricks_2_wide', description: 'Facing bricks - 2 br wide', net: 0.00, unit: 'm2', rate: 194.04, total: 0 },
    { id: 'boe_coping_2_wide', description: 'BoE coping - 2.0 br wide', net: 0.00, unit: 'm', rate: 70.96, total: 0 },
    { id: 'as_dug_backfill', description: 'As dug Backfill', net: 0.00, unit: 'm2', rate: 7.08, total: 0 },
    { id: 'stockpile_onsite', description: 'Stockpile Onsite', net: 0.00, unit: 'm3', rate: 2.77, total: 0 },
    { id: 'pipe_perforated', description: '150mm Ø perforated pipe', net: 0.00, unit: 'm', rate: 13.52, total: 0 },
    { id: 'concrete_haunching', description: 'Concrete haunching', net: 0.00, unit: 'm3', rate: 194.07, total: 0 },
    { id: 'waterproofing_2_coat', description: 'Waterproofing (RIW 2 coat + protection board)', net: 0.00, unit: 'm2', rate: 31.67, total: 0 },
    { id: 'weepholes', description: '75 dia weepholes at 1000 ccs', net: 0.00, unit: 'nr', rate: 0.94, total: 0 },
    { id: 'fence_post', description: 'Fence post at 2400mm ccs', net: 0.00, unit: 'nr', rate: 19.35, total: 0 }
  ],
  netTotal,
  ohpPercent: 15,
  ohpAmount: netTotal * 0.15,
  grandTotal: netTotal * 1.15
});

// Generate all GRW specifications
const grw750Specification = createGRWSpecification('750', 365.50);
const grw900Specification = createGRWSpecification('900', 395.20);
const grw1050Specification = createGRWSpecification('1050', 425.80);
const grw1200Specification = createGRWSpecification('1200', 458.40);
const grw1500Specification = createGRWSpecification('1500', 525.60);
const grw1800Specification = createGRWSpecification('1800', 598.20);
const grw2000Specification = createGRWSpecification('2000', 652.40);

// Generate all DRW specifications
const drw900Specification = createDRWSpecification('900', 195.80);
const drw1050Specification = createDRWSpecification('1050', 215.40);
const drw1200Specification = createDRWSpecification('1200', 235.20);
const drw1500Specification = createDRWSpecification('1500', 278.60);
const drw1800Specification = createDRWSpecification('1800', 325.40);
const drw2000Specification = createDRWSpecification('2000', 358.80);
const drw2250Specification = createDRWSpecification('2250', 398.50);
const drw2500Specification = createDRWSpecification('2500', 442.20);
const drw2750Specification = createDRWSpecification('2750', 488.60);
const drw3000Specification = createDRWSpecification('3000', 538.40);

// Generate CCRW specifications (Concrete Core Walls)
const ccrw1500Specification = createCCRWSpecification('1500', 405.40);
const ccrw1800Specification = createCCRWSpecification('1800', 489.40);
const ccrw2000Specification = createCCRWSpecification('2000', 545.40);
const ccrw2250Specification = createCCRWSpecification('2250', 615.40);
const ccrw2500Specification = createCCRWSpecification('2500', 685.40);
const ccrw2750Specification = createCCRWSpecification('2750', 752.80);
const ccrw3000Specification = createCCRWSpecification('3000', 825.60);
const ccrw3250Specification = createCCRWSpecification('3250', 895.60);
const ccrw3500Specification = createCCRWSpecification('3500', 965.60);

// All wall specifications organized by type
export const wallSpecifications: WallSpecification[] = [
  // Garden Retaining Walls
  grw450Specification,
  grw600Specification,
  grw750Specification,
  grw900Specification,
  grw1050Specification,
  grw1200Specification,
  grw1500Specification,
  grw1800Specification,
  grw2000Specification,
  // Drive Retaining Walls
  drw450Specification,
  drw600Specification,
  drw750Specification,
  drw900Specification,
  drw1050Specification,
  drw1200Specification,
  drw1500Specification,
  drw1800Specification,
  drw2000Specification,
  drw2250Specification,
  drw2500Specification,
  drw2750Specification,
  drw3000Specification,
  // Concrete Core Walls
  ccrw1500Specification,
  ccrw1800Specification,
  ccrw2000Specification,
  ccrw2250Specification,
  ccrw2500Specification,
  ccrw2750Specification,
  ccrw3000Specification,
  ccrw3250Specification,
  ccrw3500Specification,
];

// Map from field name in retainingWallsTable to specification ID
export const wallFieldToSpecId: { [key: string]: string } = {
  grw450: 'grw450',
  grw600: 'grw600',
  grw750: 'grw750',
  grw900: 'grw900',
  grw1050: 'grw1050',
  grw1200: 'grw1200',
  grw1500: 'grw1500',
  grw1800: 'grw1800',
  grw2000: 'grw2000',
  drw450: 'drw450',
  drw600: 'drw600',
  drw750: 'drw750',
  drw900: 'drw900',
  drw1050: 'drw1050',
  drw1200: 'drw1200',
  drw1500: 'drw1500',
  drw1800: 'drw1800',
  drw2000: 'drw2000',
  drw2250: 'drw2250',
  drw2500: 'drw2500',
  drw2750: 'drw2750',
  drw3000: 'drw3000',
  ccrw1500: 'ccrw1500',
  ccrw1800: 'ccrw1800',
  ccrw2000: 'ccrw2000',
  ccrw2250: 'ccrw2250',
  ccrw2500: 'ccrw2500',
  ccrw2750: 'ccrw2750',
  ccrw3000: 'ccrw3000',
  ccrw3250: 'ccrw3250',
  ccrw3500: 'ccrw3500',
};

// Maps BuildUpItem.id to evaluate code for item library rate lookup.
export const WALLS_BUILD_UP_ITEM_CODE_MAP: Record<string, string> = {
  // Excavation & formation
  excavate_trench:                        "GWALPGW0026",
  compact_formation:                      "GWALPGW0027",

  // Concrete
  concrete_blinding:                      "GWALPGW0015",
  concrete_foundation:                    "GWALPGW0013",
  concrete_haunching:                     "GWALPGW0023",
  concrete_stem:                          "GWALPGW0014",
  concrete_core:                          "GWALPGW0014",

  // Mesh (horizontal)
  a393_mesh:                              "GWALPRM004",
  a252_mesh:                              "GWALPRM003",
  b503_mesh:                              "GWALPRM006",
  b785_mesh:                              "GWALPRM007",

  // Mesh (vertical)
  a393_mesh_vertical:                     "GWALPGW0033",
  a252_mesh_vertical:                     "GWALPGW0034",
  b503_mesh_vertical:                     "GWALPGW0035",
  b785_mesh_vertical:                     "GWALPGW0036",

  // Rebar
  rebar:                                  "GWALPGW0019",

  // 7n Concrete Blockwork — all height variants share one code
  blockwork_100_0_100:                    "GWALPS007",
  blockwork_100_0_220:                    "GWALPS007",
  blockwork_100_0_330:                    "GWALPS007",
  blockwork_100_0_440:                    "GWALPS007",
  blockwork_100_0_550:                    "GWALPS007",
  blockwork_100_0_660:                    "GWALPS007",
  blockwork_100_0_770:                    "GWALPS007",
  blockwork_100_0_880:                    "GWALPS007",

  // Facing Brickwork — Free issue
  facing_brickwork_free_issue:            "GWALPGW0021",

  // Facing Brickwork — M&J Supply
  facing_brickwork_m_j_supply:            "GWALPGW0020",
  // Facing Brickwork — width variants (default to free-issue code; resolver overrides per dropdown)
  facing_bricks_05_wide:                  "GWALPGW0021",
  facing_bricks_1_wide:                   "GWALPGW0021",
  facing_bricks_15_wide:                  "GWALPGW0021",
  facing_bricks_2_wide:                   "GWALPGW0021",
  facing_bricks_25_wide:                  "GWALPGW0021",
  facing_bricks_3_wide:                   "GWALPGW0021",
  facing_bricks_35_wide:                  "GWALPGW0021",

  // BoE Coping — every width shares the single base library code (GWALPGW008
  // = 1 br wide rate) and re-derives the effective per-row rate as
  // `libraryRate × width` via `WALLS_BUILD_UP_RATE_MULTIPLIERS` (1 br → ×1,
  // 1.5 br → ×1.5, 2 br → ×2, 2.5 br → ×2.5). Same pattern as
  // 100mm-blockwork course counts and facing-brickwork half-brick widths.
  boe_coping_1_wide:                      "GWALPGW008",
  boe_coping_15_wide:                     "GWALPGW008",
  boe_coping_2_wide:                      "GWALPGW008",
  boe_coping_25_wide:                     "GWALPGW008",

  // Backfill & disposal
  as_dug_backfill:                                    "GWALP034",
  stockpile_onsite:                                   "GWALP033",

  // Drainage
  pipe_perforated:                                    "GWALPGW0024",
  "150mm_perforated_pipe":                            "GWALPGW0024",  // slug alias for items saved before description normalisation
  granular_backfill:                                  "GWALPGW0032",
  weepholes:                                          "GWALPGW0016",

  // Waterproofing
  waterproofing_1_coat:                               "GWALPGW0028",
  aquaseal_memb:                                      "GWALPGW0029",
  waterproofing_2_coat:                               "GWALPGW0030",

  // Other
  terram:                                             "ALP031",
  fence_post:                                         "GWALPGW0022",

  // Geo Wall installation
  install_geo_walls:                                  "GWALPGW0037",
  purchase_incl_carriage_waste_fp:                    "ZEV23",

  // Additionals
  additional_excavation:                              "GWALPGW0026",
  additional_concrete:                                "GWALPGW0015",

  // Screen Wall
  screen_wall_foundation_free_issue:                  "GWALPGW003",
  eo_pillers:                                         "GWALPGW003A",
  screen_wall_foundation_m_j_supply:                  "GWALPGW003B",
  eo_pillers_m_j_supply:                              "GWALPGW003C",

  // Miscellaneous
  slab_on_edge:                                       "GWALPGW0043",
  log_wall_n_e_1200mm:                                "GWALPGW0044",
  gravel_board:                                       "GWALPGW0023",

  // Tobermore Wall items
  excavation_of_embankment:                           "GWALPGW0026",
  batter_to_face_of_embankment:                       "GWALPGW0027",
  excavation_of_base:                                 "GWALPGW0026",
  level_compact_formation:                            "GWALPGW0027",
  concrete_to_base:                                   "GWALPGW0013",
  tobermore_supply_of_grand_secura_incl_fp:           "SCAANC007",
  tobermore_secura_installation_by_m_j:               "GWALPGW0037",
  tobermore_supply_of_geogrid:                        "SCAANC007",
  m_j_installation_of_geogrid:                       "ALP032B",
  free_draining_granular_backfill_300w_column:        "GWALPGW0032",
  granular_backfill_to_rear_of_wall:                  "GWALPGW0032",
  land_drain_to_rear_of_wall:                         "GWALPGW0024",
  allow_silt_trap:                                    "GWALPDD019",
  allow_to_connect_of_land_drain_to_plot_drainage:    "GWALPDD057",
};

// Wall categories for organization
export const wallCategories = {
  garden: 'Garden Retaining Walls',
  drive: 'Drive Retaining Walls',
  concrete: 'Concrete Core Retaining Walls'
};

// Categories for organizing build-up items
export const buildUpCategories = {
  excavation: [
    'excavate_trench',
    'compact_formation',
    'stockpile_onsite'
  ],
  foundation: [
    'concrete_blinding',
    'concrete_foundation',
    'a393_mesh',
    'a252_mesh',
    'b503_mesh',
    'b785_mesh'
  ],
  blockwork: [
    'blockwork_100_0_100',
    'blockwork_100_0_220',
    'blockwork_100_0_330',
    'blockwork_100_0_440',
    'blockwork_100_0_550',
    'blockwork_100_0_660',
    'blockwork_100_0_770',
    'blockwork_100_0_880'
  ],
  brickwork: [
    'facing_bricks_05_wide',
    'facing_bricks_1_wide',
    'facing_bricks_15_wide',
    'facing_bricks_2_wide',
    'facing_bricks_25_wide',
    'facing_bricks_3_wide',
    'facing_bricks_35_wide'
  ],
  coping: [
    'boe_coping_1_wide',
    'boe_coping_15_wide',
    'boe_coping_2_wide',
    'boe_coping_25_wide'
  ],
  drainage: [
    'pipe_perforated',
    'concrete_haunching',
    'weepholes'
  ],
  waterproofing: [
    'waterproofing_1_coat',
    'waterproofing_2_coat',
    'aquaseal_memb',
    'terram'
  ],
  backfill: [
    'as_dug_backfill',
    'granular_backfill'
  ],
  finishing: [
    'fence_post'
  ]
};

// ─── Facing Brickwork code resolver ─────────────────────────────────────────
// The Configure modal on the Retaining Walls page lets the user pick between
// two Facing Brickwork variants. The choice is stored as a label string on
// `tender.groundworks.wallsBuildUpConfig.facingBrickworkLabel`:
//   - 'Facing Brickwork – free issue'  → free issue (M&J labour only) → GWALPGW0021
//   - 'Facing Brickwork - M&J Supply' → M&J supply + labour          → GWALPGW0020
// All `facing_bricks_*_wide` items in `wallSpecifications` use the resolved
// code to pull the item-library rate, so swapping the dropdown immediately
// changes the rate on every Facing Brickwork build-up row, in every
// downstream consumer (BoQ Bill Summary, Excel export, Sum Analysis, Plot
// Matrix). Pass `WALLS_BUILD_UP_ITEM_CODE_MAP[id]` as the fallback for IDs
// outside the `facing_bricks_*` family.
export const FACING_BRICKWORK_FREE_ISSUE_LABEL = 'Facing Brickwork – free issue';
export const FACING_BRICKWORK_M_J_SUPPLY_LABEL = 'Facing Brickwork - M&J Supply';
export const FACING_BRICKWORK_FREE_ISSUE_CODE = 'GWALPGW0021';
export const FACING_BRICKWORK_M_J_SUPPLY_CODE = 'GWALPGW0020';

/**
 * Returns true for any Facing Brickwork build-up row, regardless of which
 * id convention the persisted data uses:
 *   - `facing_bricks_*_wide` — current spec convention
 *   - `facing_brickwork_*`   — legacy id from older saves (free_issue / m_j_supply)
 *   - any id whose static evaluate code in `WALLS_BUILD_UP_ITEM_CODE_MAP` is
 *     `GWALPGW0020` or `GWALPGW0021` — catches data where the persisted id
 *     was derived from a substituted description ("Facing Brickwork - 1 br
 *     wide" → slug `facing_brickwork_1_br_wide`).
 */
export function isFacingBrickworkItem(id: string | undefined): boolean {
  if (!id) return false;
  if (id.startsWith('facing_bricks_')) return true;
  if (id.startsWith('facing_brickwork_')) return true;
  const mapped = WALLS_BUILD_UP_ITEM_CODE_MAP[id];
  return mapped === FACING_BRICKWORK_FREE_ISSUE_CODE || mapped === FACING_BRICKWORK_M_J_SUPPLY_CODE;
}

export function resolveWallsBuildUpItemCode(
  id: string | undefined,
  facingBrickworkLabel?: string,
): string | undefined {
  if (isFacingBrickworkItem(id)) {
    return facingBrickworkLabel === FACING_BRICKWORK_M_J_SUPPLY_LABEL
      ? FACING_BRICKWORK_M_J_SUPPLY_CODE
      : FACING_BRICKWORK_FREE_ISSUE_CODE;
  }
  return id ? WALLS_BUILD_UP_ITEM_CODE_MAP[id] : undefined;
}

// ─── Walls build-up rate multipliers ────────────────────────────────────────
// Some build-up rows share a single item-library code but represent multiple
// "courses" / "widths" of that base unit:
//   • 100mm blockwork — every `blockwork_100_0_*` row maps to `GWALPS007` and
//     stacks N 100mm courses ("220" = 2, "330" = 3, …, up to "880" = 8).
//   • Facing brickwork — every `facing_bricks_*_wide` row maps to
//     `GWALPGW0020` / `GWALPGW0021` (which one is picked by the Configure
//     dropdown) and represents N half-brick widths
//     ("0.5 br wide" = 1, "1 br wide" = 2, "1.5 br wide" = 3, …, up to
//     "3.5 br wide" = 7).
//   • BoE coping — every `boe_coping_*_wide` row maps to `GWALPGW008` (the
//     1 br wide base rate) and applies the brick-width as a fractional
//     multiplier ("1 br wide" = 1, "1.5 br wide" = 1.5, "2 br wide" = 2,
//     "2.5 br wide" = 2.5).
// The Bill Summary, Sum Analysis, BoQ JSON and BoQ Excel paths all need to
// bill these rows as `libraryRate × N`, and the build-up rate cell displays
// the decomposed `baseRate × N` so the estimator can see where the
// multiplier comes from. Keep this table and `hasWallsBuildUpRateMultiplier`
// / `getWallsBuildUpRateMultiplier` together — the bill-summary consumers
// import the helper and rely on it returning `1` for any id not listed here.
// Note: `N` is `number` (not `integer`) — BoE coping uses 1.5 / 2.5.
export const WALLS_BUILD_UP_RATE_MULTIPLIERS: Record<string, number> = {
  // 100mm blockwork course count
  blockwork_100_0_100: 1,
  blockwork_100_0_220: 2,
  blockwork_100_0_330: 3,
  blockwork_100_0_440: 4,
  blockwork_100_0_550: 5,
  blockwork_100_0_660: 6,
  blockwork_100_0_770: 7,
  blockwork_100_0_880: 8,
  // Facing brickwork half-brick width count
  facing_bricks_05_wide: 1,
  facing_bricks_1_wide: 2,
  facing_bricks_15_wide: 3,
  facing_bricks_2_wide: 4,
  facing_bricks_25_wide: 5,
  facing_bricks_3_wide: 6,
  facing_bricks_35_wide: 7,
  // BoE coping brick-width (fractional)
  boe_coping_1_wide: 1,
  boe_coping_15_wide: 1.5,
  boe_coping_2_wide: 2,
  boe_coping_25_wide: 2.5,
};

export function getWallsBuildUpRateMultiplier(id: string | undefined): number {
  if (!id) return 1;
  return WALLS_BUILD_UP_RATE_MULTIPLIERS[id] ?? 1;
}

/**
 * Returns true for any walls build-up row whose effective rate is
 * `libraryRate × N` rather than a per-row rate read from the persisted
 * spec. Covers 100mm-blockwork course-count rows AND facing-brickwork
 * half-brick-width rows (see `WALLS_BUILD_UP_RATE_MULTIPLIERS`).
 */
export function hasWallsBuildUpRateMultiplier(id: string | undefined): boolean {
  if (!id) return false;
  return id in WALLS_BUILD_UP_RATE_MULTIPLIERS;
}

/**
 * @deprecated Use `hasWallsBuildUpRateMultiplier` instead — the function
 * now also returns true for facing-brickwork rows. Kept as an alias so
 * existing imports continue to compile until they're migrated.
 */
export const isBlockworkBuildUpItem = hasWallsBuildUpRateMultiplier;